import React from 'react';

const KPICard = ({ title, value, icon: Icon, color = 'primary' }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'bg-success-100 dark:bg-success-500/10 text-success-600 dark:text-success-500';
      case 'warning':
        return 'bg-warning-100 dark:bg-warning-500/10 text-warning-600 dark:text-warning-500';
      case 'error':
        return 'bg-error-100 dark:bg-error-500/10 text-error-600 dark:text-error-500';
      case 'highlight':
        return 'bg-highlight-100 dark:bg-highlight-500/10 text-highlight-600 dark:text-highlight-500';
      default:
        return 'bg-primary-100 dark:bg-primary-500/10 text-primary-600 dark:text-primary-500';
    }
  };

  return (
    <div className="bg-white dark:bg-dark-background-main rounded-xl border border-background-secondary dark:border-dark-border shadow-sm hover:shadow-md transition-all duration-200">
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="font-dynamic-text font-medium text-text-secondary dark:text-dark-text-secondary mb-1">
              {title}
            </p>
            <p className="font-dynamic-title font-bold text-text-primary dark:text-dark-text-primary">
              {value}
            </p>
          </div>
          {Icon && (
            <div className={`p-2 rounded-lg ${getColorClasses()}`}>
              <Icon className="h-5 w-5" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KPICard;